import React, { useMemo } from "react";
import PhoneNumberInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "styles/phone-input.css";

interface IPhoneInputProps {
  name: string;
  label?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  disableDropdown?: boolean;
  onFocus?: any;
  onBlur?: any;
  defaultCountry?: string;
  values?: any;
  errors?: any;
  touches?: any;
}

export const PhoneInput: React.FC<IPhoneInputProps> = ({
  label,
  name,
  values,
  placeholder,
  onChange,
  disabled,
  disableDropdown,
  onFocus,
  onBlur,
  defaultCountry,
  errors,
  touches,
}) => {
  const isInvalid = useMemo(() => {
    return touches[name] && errors[name];
  }, [touches, errors, name]);
  return (
    <div className='space-y-1 relative'>
      <label className={`text-[11px] font-bold text-Black`}>{label}</label>
      <PhoneNumberInput
        inputStyle={{ width: "100%", borderColor: "#f9f8fc" }}
        specialLabel={""}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
        disableDropdown={disableDropdown}
        onFocus={onFocus}
        onBlur={onBlur}
        country={defaultCountry ? defaultCountry : "gb"}
        value={values[name]}
      />

      {isInvalid && (
        <div
          style={{ color: "#ef4444" }}
          className='font-bold text-[10px] absolute'
        >
          {errors[name]}
        </div>
      )}
    </div>
  );
};
